export default __webpack_public_path__ + "static/media/nemesysco.89a96489.jpg";